import { Box, Typography } from "@mui/material";
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface JsonPreviewProps {
  schema: object;
}

export default function JsonPreview({ schema }: JsonPreviewProps) {
  return (
    <Box mt={2}>
      <Typography variant="h6" mb={2}>
        Anteprima JSON Schema
      </Typography>
      <SyntaxHighlighter
        language="json"
        style={vscDarkPlus}
        customStyle={{
          borderRadius: '4px',
          fontSize: '14px',
        }}
      >
        {JSON.stringify(schema, null, 2)}
      </SyntaxHighlighter>
    </Box>
  );
}